// filepath: client/src/pages/Dashboard/VoucherDashboard.jsx
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { Page, Layout, Card, Text, Button, InlineGrid } from '@shopify/polaris';
import { BillIcon } from '@shopify/polaris-icons';
import { SessionContext } from '#client/contexts/SessionContext.jsx';
import Tile from '#client/pages/Dashboard/Tile';
import '#client/pages/Dashboard/Dashboard.css';

const VoucherDashboard = () => {
    const { customerLogout } = useContext(SessionContext);
    const navigate = useNavigate();
    const go = (url) => navigate(url, { viewTransition: true });

    return (
        <Page title="Dashboard" fullWidth>
            <Layout>
                <Layout.Section>
                    <Card>
                        <Text variant="headingMd" as="h2">
                            Voucher Administration
                        </Text>
                        <Text as="p">This is your dashboard to view programs you administer and manage vouchers.</Text>
                        <div style={{ marginTop: 12 }}>
                            <Button onClick={customerLogout}>Logout</Button>
                        </div>
                    </Card>
                </Layout.Section>

                {/* Programs tile row */}
                <Layout.Section>
                    <Card>
                        <InlineGrid gap="400" columns={{ xs: 1, sm: 2, md: 2, lg: 3 }}>
                            <Tile
                                title="Programs"
                                icon={BillIcon}
                                description="View company voucher programs"
                                // Customer-scoped programs route:
                                button={{ label: 'View', onClick: () => go('/customer/programs') }}
                            />
                        </InlineGrid>
                    </Card>
                </Layout.Section>
            </Layout>
        </Page>
    );
};

export default VoucherDashboard;
